
import { connect } from 'react-redux';
import Enterprises from './Enterprises';
import { setProgressBarStatus } from '../../redux/actions/progressBar';

const mapStateToProps = null;

const mapDispatchToProps = {
  setProgressBarStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(Enterprises);
